import {
  Box,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemButtonProps,
  ListItemText,
  Typography,
  styled,
} from '@mui/material';
import { ReactNode } from 'react';

export interface TransactionListItemProps extends ListItemButtonProps {
  title: string | undefined;
  subtitle?: string | null;
  value: ReactNode;
  subvalue?: string;
  icon: React.ReactNode;
}

const TextBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
}));

export function TransactionListItem({
  title,
  subtitle,
  value,
  subvalue,
  icon,
  ...props
}: TransactionListItemProps) {
  return (
    <ListItem disablePadding>
      <ListItemButton {...props}>
        <ListItemAvatar>{icon}</ListItemAvatar>
        <ListItemText
          primary={
            <TextBox>
              <Typography variant="body1" sx={{ wordBreak: 'break-all' }}>
                {title}
              </Typography>
              {value}
            </TextBox>
          }
          secondary={
            <TextBox>
              <Typography
                variant="caption"
                sx={{
                  color: 'text.secondary',
                }}
              >
                {subtitle}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: 'text.secondary',
                }}
              >
                {subvalue}
              </Typography>
            </TextBox>
          }
          disableTypography
          sx={{ maxWidth: '100%', overflow: 'hidden' }}
        />
      </ListItemButton>
    </ListItem>
  );
}
